export const NotifyIcons = {
	warning: 'failures',
	info: 'o_info',
	success: 'x_check',
} as const;
